import {useState, useContext, useEffect} from 'react'
import callContext from '@/pages/crm/callCenter/callManage/callManageContext'
import { InputItem } from './inputItem'
import { Button, Radio } from 'antd'
import AdvancedFilter from '../AdvancedFilter'
import { isArray } from 'lodash-es'

import AddClueModal from './addClueModal'
import { message } from 'antd'
import DuplicatedModal from './duplicatedModal'
import {callBatchReceive, clueInfoBatchReceive, getSeatAccountByWorkNumber} from '@/services/callCenter'
import { clueServiceEdit } from '@/pages/crm/publicInformation/detail/clueServiceEdit'

import { SoftPhoneBar, triggerEvent, SOFT_PHONE_EVENTS } from '@shj/use-soft-phone'
import {useSoftPhone} from '@/components/shj-soft-phone'

import { useDebounceEffect } from 'ahooks'
import { getAuth } from '@/utils/auth'
import { useNavigate } from 'react-router-dom'
import {getEnums} from "@/services/homeService.ts";
import {getUser} from "@/common/utils.ts";
import {callReceive, getClueButton, getSeatAccount} from "@/services/saleOpServices.ts";
import {getHandleButtonObj} from "@/utils/btn.ts";
import {getSeatAccountOne} from "@/services/crmTool.ts";

function Head(props: any) {
  const auth = getAuth()
  const { updateCallManageState, callManageState } = useContext(callContext)
  const {
    callFormData,
    checkClueList,
    detailParameter,
    refreshList,
    callBtnState,
    callAllState = {},
  } = callManageState || {}
  const {
    sourceChannelList, //客户来源列表
    bizOpPropertyTypeList, // 房屋属性列表
    companyList,
    cityArea,
    quickTime, //快捷时间列表
  } = props
  const [advancedVisible, setAdvancedVisible] = useState(false)
  const [checkId, setCheckId] = useState('ALL') // tab选中值
  const [addClueVisible, setAddClueVisible] = useState(false) // 新增线索弹窗显示
  const [clueBtnLoading, setClueBtnLoading] = useState(false) // 领取线索按钮加载状态
  const [hasBeenScreening, sethasBeenScreening] = useState(false) //是否筛选
  const [duplicateVisible, setDuplicateVisible] = useState(false) // 查重状态
  const [isBtnObj, setIsBtnObj] = useState({}) // 按钮

  useEffect(() => {
    if (callManageState.detailParameter?.id) fetchPermission()
  }, [callManageState.detailParameter]);

  // 请求按钮权限
  const fetchPermission = async () => {
    const arr = await getClueButton(callManageState.detailParameter.id)
    console.log(arr, 1111)
    const isBtnObj = await getHandleButtonObj(arr)
    if (isBtnObj) setIsBtnObj({ ...isBtnObj })
  }
  const [menusList, setMenusList]: any = useState([
    [
      { label: '全部', value: 'ALL' },
      { label: '信息', value: 'BEGIN_STATUS' },
      { label: '待定', value: 'CALL_USER_PENDING' },
      { label: '有效', value: 'CALL_VALID' },
      { label: '派单', value: 'CLUE,SALE_MAN_PENDING,ORDINARY_MSG,VALID_MSG,DESIGN,INVALID,TO_SHOP' },
    ],
    [{ label: '公海', value: 'GH' }],
  ])

  // const navigate = useNavigate()
  // const isDev = process.env.NODE_ENV === 'development'
  // const [softPhoneAPI] = useSoftPhone({
  //   // createElement: document.createElement,
  //   onload: () => {
  //     console.log('iframe onload', isDev)
  //     if (isDev) {
  //       // softPhoneAPI.login({
  //       //   thirdAccount: '8004@songwt1',
  //       //   password: '123abc',
  //       // })
  //       // softPhoneAPI.showDebug()
  //       const userInfo = getUser?.()
  //       // console.log('1111', 'emit')
  //       getSeatAccountOne({userId: userInfo.ucenterUserId, brand: 'HELI' }).then(res => softPhoneAPI.login(res))
  //     } else {
  //       const userInfo = getUser?.()
  //       // console.log('2222', 'emit', userInfo.ucenterUserId)
  //       getSeatAccountOne({userId: userInfo.ucenterUserId, brand: 'HELI' }).then(res => softPhoneAPI.login(res))
  //     }
  //   },
  //   register: () => {
  //     console.log('resister----------》')
  //     updateCallManageState({ isCallSystemUser: true })
  //   },
  //   showMessage: msg => message.info(msg),
  //   onLink: () => {
  //     // updateSoftPhone(true, 'fromPanelLink')
  //     // updateCallAllState({ callJumpRefresh: true, searchType: 'search', detailsDispatchStatus: '全部', tabValue: '全部' })
  //     // updateCallFormData({ ...formData, key: _.get(softPhone, 'detailData.id'), dispatchStatus: '', publicSea: false, pageNum: 1, pageSize: 20, detail: false, })
  //     // updateCallList({ refresh: !callList.refresh, listState: true })
  //     console.log('onLink')
  //     // navigate(`/marketCloud/callCenter`)
  //   },
  //   // debug: isDev,
  // })

  useDebounceEffect(
    () => {
        // softPhoneAPI.init()
      // if (window.microApp) {
      //   console.log('callManage head init')
      // }
    },
    [],
    { wait: 100 }
  )

  const getRole = () => {
    const roleJson = localStorage.getItem('userExtend')
    let arr = []
    try {
      if (roleJson) {
        arr = JSON.parse(roleJson)?.roleCodes || []
      }
      return arr
    } catch (error) {
      return []
    }
  }
  //角色A1119 0 拥有梵高cc回访池 权限
  // const arr = getRole()
  // if (arr.filter(item => item === 'A1119' || item === '0').length > 0) {
  //   menusList = [menusList[0], [...menusList[1], { label: '梵高cc回访池', value: 'FG' }]]
  // }
  /**
   *  高级筛选字段
   *  如果高级筛选中新增了筛选条件，则需要把字段填写在下面，
   *  方便条件判断是否已筛选了
   */
  const advancedScreeningField = [
    'houseNatureCode',
    'companyCode',
    'channelIds',
    'signTime',
    'dispatchTime',
    'lastFollowTime',
    'lastCallTime',
    'dispatchStatus',
    'deptCode',
    'workNumberList',
    'dispatchDateRange',
    'isReturn',
    'isSign',
  ]

  // tab切换
  const tabClick = (e: any) => {
    const value = e?.target?.value
    setCheckId(value)
    const obj = menusList.flat(1).find(e => e.value === value) || {}
    if (checkClueList.length) {
      updateCallManageState({
        checkClueList: [],
      })
    }

    const mergeObj = {
      ...callFormData,
      statusList: ['公海', '梵高cc回访池', '全部'].includes(obj?.label) ? '' : value?.split(','),
      // isPublic: obj?.label === '公海' || obj?.label === '梵高cc回访池' ? 1 : 0,
      publicSea: obj?.label === '公海' ? 'public_seat' : null,
    }
    // 如果tab状态为信息、待定、公海，则 dispatchStatus设置为[]
    if (['信息', '待定', '公海'].includes(obj?.label)) {
      mergeObj.dispatchStatus = []
    }
    hasBeenScreeningFn(mergeObj)
    updateCallManageState({
      callFormData: mergeObj,
      advancedFormData: mergeObj,
      callAllState: { ...callAllState, tabValue: obj?.label },
      currentPage: 1,
      refreshList: !refreshList,
    })
  }

  // 高级弹框取消
  const advancedOnCancel = () => {
    setAdvancedVisible(false)
  }
  // 高级弹框确定
  const advancedOnOk = (data: any) => {
    hasBeenScreeningFn(data)
  }
  // 检车高级筛选里面是否已经筛选了值
  const hasBeenScreeningFn = (data: any) => {
    const state = advancedScreeningField.find(d => {
      if (isArray(data[d])) {
        if (data[d].length) return true
        return false
      } else if (data[d] + '' === '0' || data[d]) {
        return true
      }
      return false
    })
    sethasBeenScreening(state)
  }

  // 领取线索
  const getClue = () => {
    if (clueBtnLoading) return
    setClueBtnLoading(true)
    callBatchReceive({clueIds: checkClueList})
      .then((res: any) => {
        updateCallManageState({
          checkClueList: [],
          refreshList: !refreshList,
        })
        message.success(res?.message || '操作成功')
      })
      .finally(() => {
        setClueBtnLoading(false)
      })
  }

  return (
    <div style={{ backgroundColor: '#fff' }}>
      <div style={{ display: 'flex', marginTop: '0', padding: '10px 0' }}>
        <div style={{ margin: '0 6px', minWidth: '100px', height: '32px' }}>
          <Radio.Group
            options={menusList.flat(1)}
            onChange={tabClick}
            value={checkId}
            optionType="button"
            style={{ display: 'flex' }}
          />
        </div>

        <SoftPhoneBar />

        <div style={{ margin: '0 6px' }}>
          <InputItem
            callDisabled={callBtnState.loading || callBtnState.disabled}
            showCallOption={callManageState.isCallSystemUser}
            onCall={value => {
              if (!/^1\d{10}$/.test(value)) return message.warning('电话号码格式不正确')
              const userInfo = getUser?.()
              triggerEvent(SOFT_PHONE_EVENTS.SOFT_PHONE_DIALOUT, {
                phone: value,
                interfaceData: {
                  agentName: userInfo.userName,
                  tenantId: userInfo.ucenterUserId,
                  agentType: 'SEAT',
                },
              })
            }}
          />
        </div>
        <Button
          style={{ margin: '0 6px', fontSize: '14px', display: 'flex', alignItems: 'center' }}
          type="primary"
          onClick={() => setAdvancedVisible(true)}
        >
          {hasBeenScreening ? '已' : ''}筛选
        </Button>
        {auth['CallClueAdd'] && (
          <Button
            type="primary"
            ghost
            style={{ margin: '0 6px', fontSize: '14px' }}
            onClick={() => setAddClueVisible(true)}
          >
            新增
          </Button>
        )}
        {(isBtnObj['ASSIGN_SEAT_MAN']) && (
              <Button
                type="primary"
                ghost
                style={{ margin: '0 6px', fontSize: '14px' }}
                onClick={() => {
                  if (!checkClueList.length) return message.warning('请勾选')
                  clueServiceEdit({
                    ids: checkClueList,
                    type: '云客服',
                    fn: () => {
                      updateCallManageState({
                        refreshList: !refreshList,
                      })
                    },
                    buttonKey: 'ASSIGN_SEAT_MAN'
                  })
                }}
              >
                改派云客服
              </Button>
            )}
        {['GH', 'FG'].includes(checkId)
          ? auth['CallCluePickFromOcean'] && (
              <Button
                loading={clueBtnLoading}
                disabled={!checkClueList.length}
                type="primary"
                ghost
                style={{ margin: '0 6px', fontSize: '14px' }}
                onClick={() => getClue()}
              >
                领取线索
              </Button>
            )
          : null}

        <Button
          type="primary"
          ghost
          style={{ margin: '0 6px', fontSize: '14px' }}
          onClick={() => setDuplicateVisible(true)}
        >
          查重
        </Button>
      </div>
      <AdvancedFilter
        companyList={companyList}
        clueStateList={menusList[0]}
        cityArea={cityArea}
        visible={advancedVisible}
        onOk={advancedOnOk}
        onCancel={advancedOnCancel}
        bizOpPropertyTypeList={bizOpPropertyTypeList}
        sourceChannelList={sourceChannelList}
        quickTime={quickTime}
      />
      <DuplicatedModal open={duplicateVisible} onCancel={() => setDuplicateVisible(false)} />
      <AddClueModal
        bizOpPropertyTypeList={bizOpPropertyTypeList}
        sourceChannelList={sourceChannelList}
        open={addClueVisible}
        onCancel={() => setAddClueVisible(false)}
        fn={() => {
          updateCallManageState({
            refreshList: !refreshList,
          })
        }}
      />
    </div>
  )
}

export default Head
